<app-page-header
    title="Configuración de Documentos"
    mobileTitle="Documentos"
    icon="fas fa-file-signature"
    optionsLabel="Opciones"
    optionsIcon="fa fa-cog"
    [hasOptions]="true">
    <div headerOptions>
        <a class="dropdown-item" routerLink="/configuracion/documentos/historial">
            <i class="fas fa-history fa-fw me-2 text-primary"></i> Historial de cambios
        </a>
    </div>
</app-page-header>

<div class="row">
    <div class="col-12"
         [class.col-md-12]="!appSettings.isMobile()"
         [class.mobile-requests-container]="appSettings.isMobile()">
        <div class="mobile-list-shell" [class.panel]="!appSettings.isMobile()" [class.p-3]="!appSettings.isMobile()">
            <app-doc-process-list />
        </div>
    </div>
</div>
